import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SALES_EMAIL = "sales@pizzaexcellente.com";
export const MAILTO = `mailto:${SALES_EMAIL}`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("pe_admin_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (detail?.msg) return detail.msg;
  return fallback;
}
